import { Navigate, Route, Routes } from 'react-router';

import { AuthCallbackPage } from './AuthCallbackPage';
import { useConfig } from './contexts/ConfigContext';
import { Layout } from './Layout';
import { LoginPage } from './pages/LoginPage';
import { HomePage } from './pages/HomePage';
import { AdminPage } from './pages/AdminPage';
import { CaseListPage } from './pages/CaseListPage';
import { CaseRecordPage } from './pages/CaseRecordPage';
import { ClientRecordPage } from './pages/ClientRecordPage';
import { ClientSearchPage } from './pages/ClientSearchPage';
import { DashboardPage } from './pages/DashboardPage';
import { EventDashboardPage } from './pages/EventDashboardPage';
import { ExportPage } from './pages/ExportPage';
import { ManageMyCasesPage } from './pages/ManageMyCasesPage';
import { NewClientPage } from './pages/NewClientPage';
import { ResourceExportPage } from './pages/ResourceExportPage';
import { ResourceLibraryPage } from './pages/ResourceLibraryPage';
import { ResourceManagePage } from './pages/ResourceManagePage';
import { CallCenterPage } from './pages/CallCenterPage';

export function App() {
  const appConfig = useConfig();

  return (
    <Routes>
      <Route path="/veterans-case-mgmt/:entitySlug" element={<Layout />}>
        <Route index element={<HomePage />} />

        {/* Dashboard */}
        <Route path="dashboard" element={<DashboardPage />} />

        {/* Clients */}
        <Route path="clients/search" element={<ClientSearchPage />} />
        <Route path="clients/new" element={<NewClientPage />} />
        <Route path="clients/:clientId" element={<ClientRecordPage />} />

        {/* Cases */}
        <Route path="cases/my" element={<ManageMyCasesPage />} />
        <Route
          path="cases/org"
          element={
            <CaseListPage
              title="Organization Cases"
              description="Cases across your organization."
            />
          }
        />
        <Route
          path="cases/org-export"
          element={
            <CaseListPage
              title="Manage & Export Organization Cases"
              description="Review and export cases assigned to your organization."
              showExport
            />
          }
        />
        <Route
          path="cases/all"
          element={
            <CaseListPage title="All Cases" description="All cases in the VCM system." showExport />
          }
        />
        <Route path="cases/:caseId" element={<CaseRecordPage />} />

        {/* Resources */}
        <Route path="resources/library" element={<ResourceLibraryPage />} />
        <Route path="resources/manage" element={<ResourceManagePage />} />
        <Route path="resources/export" element={<ResourceExportPage />} />

        {/* Events */}
        <Route path="events/dashboard" element={<EventDashboardPage />} />

        {/* Admin */}
        <Route path="admin" element={<AdminPage />} />

        {/* Call Center */}
        <Route path="call-center" element={<CallCenterPage />} />

        {/* Export */}
        <Route path="export" element={<ExportPage />} />
      </Route>
      <Route path="/veterans-case-mgmt/:entitySlug/login" element={<LoginPage />} />
      <Route path={appConfig.auth.callbackPath} element={<AuthCallbackPage />} />
      <Route path="*" element={<Navigate to="/veterans-case-mgmt/local/login" replace />} />
    </Routes>
  );
}
